module.exports = __webpack_public_path__ + "static/img/unMute_camera2.f4385b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/unMute_camera2.png
// module id = 2Dla
// module chunks = 24